import {IAttributes, IController, IModule, INgModelController, IOnChangesObject} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import _ from "lodash";
import {regNavn} from "../../../../../felles/tjenester/tredjepartsTjenestenavn";
import {Debugger} from "debug";

const debug: Debugger = require('debug')('VelgAkseptertSignaturmetodeKontroller');
const css = require('./velgAkseptertSignaturmetode.scss');

export class VelgAkseptertSignaturmetodeKontroller implements IController {

    static skjultTipsRegister: { [møteId: string]: boolean } = {};

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmVelgAkseptertSignaturmetode', {
                bindings: {standardSignaturmetoder: '<'},
                require: {ngModel: 'ngModel'},
                controller: VelgAkseptertSignaturmetodeKontroller.forInjisering(),
                template: require('./velgAkseptertSignaturmetode.html')
            });
    }

    static forInjisering() {
        return [regNavn.ng.$attrs, VelgAkseptertSignaturmetodeKontroller]
    }

    constructor(private $attrs:IAttributes) {
    }

    standardSignaturmetoder: l.AkseptertSignaturmetode[] = []; //settes via bindings
    ngModel: INgModelController; //settes via require

    enkelValgt = false;
    avansertValgt = false;
    huskSignaturmetodeValg = false;
    visHuskValg = false;

    oppdaterModell() {
        const signaturmetoder = [];
        if (this.avansertValgt) signaturmetoder.push(l.AkseptertSignaturmetode.avansertelektronisk);
        if (this.enkelValgt) signaturmetoder.push(l.AkseptertSignaturmetode.enkelelektronisk);
        //console.log("#### oppdaterModell", signaturmetoder, this.ngModel)
        this.visHuskValg = !_.isEqual(_.sortBy(signaturmetoder,_.identity), _.sortBy(this.standardSignaturmetoder, _.identity));
        this.ngModel.$setViewValue(<AkseptertSignaturmetodeSpesifikasjon>{
            signaturmetoder: signaturmetoder,
            huskSignaturmetodeValg: this.huskSignaturmetodeValg
        });
        this.setValidityRequired(!(this.erPåkrevet() && _.isEmpty(signaturmetoder)))
    }

    $onInit(): void {
        //håndter at modell oppdateres utenifra
        this.ngModel.$render = () => this.modellHarBlittOppdatert();
    }

    $onChanges(changes: IOnChangesObject) {
        dersomChangesInneholder(changes, 'standardSignaturmetoder', metode => this.modellHarBlittOppdatert());
    }
    
    //hjelpemetoder

    private modellHarBlittOppdatert() {
        //console.log("#### modellHarBlittOppdatert", this.ngModel.$viewValue)
        let nyVerdi: AkseptertSignaturmetodeSpesifikasjon = this.ngModel.$viewValue;
        if (_.isEmpty(nyVerdi?.signaturmetoder)) {
            this.huskSignaturmetodeValg = false;
            this.avansertValgt = _.includes(this.standardSignaturmetoder, l.AkseptertSignaturmetode.avansertelektronisk);
            this.enkelValgt = _.includes(this.standardSignaturmetoder, l.AkseptertSignaturmetode.enkelelektronisk);
            this.oppdaterModell();
        } else{
            this.huskSignaturmetodeValg = nyVerdi.huskSignaturmetodeValg;
            this.avansertValgt = _.includes(nyVerdi.signaturmetoder, l.AkseptertSignaturmetode.avansertelektronisk);
            this.enkelValgt = _.includes(nyVerdi.signaturmetoder, l.AkseptertSignaturmetode.enkelelektronisk);
            this.oppdaterModell();
        }
    }
    
    private erPåkrevet(){
        return !_.isNil(this.$attrs['required']);
    }

    private setValidityRequired(erGyldig:boolean){
        this.ngModel.$setValidity('required', erGyldig);
    }
}

export interface AkseptertSignaturmetodeSpesifikasjon {
    signaturmetoder: l.AkseptertSignaturmetode[];
    huskSignaturmetodeValg: boolean;
}
